<!-- Navigation Links -->
<nav class="nav flex-column">
  
  <!-- General Settings Link -->
  <a class="nav-link text-start text-decoration-none"
     [class.active]="activePanel === 'general'"
     href="#" 
     (click)="setActivePanel('general'); $event.preventDefault()">
    <i class="fa fa-cog me-2 text-primary"></i>
    General Settings
  </a>

  <!-- Email Configuration Link -->
  <a class="nav-link text-start text-decoration-none"
     [class.active]="activePanel === 'email'"
     href="#" 
     (click)="setActivePanel('email'); $event.preventDefault()">
    <i class="fa fa-envelope me-2 text-info"></i>
    Email Configuration
  </a>

  <!-- Course Management Link -->
  <a class="nav-link text-start text-decoration-none"
     [class.active]="activePanel === 'courses'"
     href="#" 
     (click)="setActivePanel('courses'); $event.preventDefault()">
    <i class="fa fa-book me-2 text-success"></i>
    Course Management
  </a>

  <!-- Security Settings Link -->
  <a class="nav-link text-start text-decoration-none"
     [class.active]="activePanel === 'security'"
     href="#" 
     (click)="setActivePanel('security'); $event.preventDefault()">
    <i class="fa fa-shield-alt me-2 text-warning"></i>
    Security Settings
  </a>

  <!-- Maintenance Link -->
  <a class="nav-link text-start text-decoration-none"
     [class.active]="activePanel === 'maintenance'"
     href="#" 
     (click)="setActivePanel('maintenance'); $event.preventDefault()">
    <i class="fa fa-tools me-2 text-danger"></i>
    Maintenance
  </a>
</nav>